// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ofMO","list":"PatternAutocomplete_list__37r5e"};